import React from 'react';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';

// Wrapper components to fix TypeScript compatibility issues
export const FiUpload: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiUpload as any, { className });
};

export const FiFile: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiFile as any, { className });
};

export const FiDownload: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiDownload as any, { className });
};

export const FiTrash2: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiTrash2 as any, { className });
};

export const FiRefreshCw: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiRefreshCw as any, { className });
};

export const FiTag: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiTag as any, { className });
};

export const FiFolder: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiFolder as any, { className });
};

export const FiGlobe: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiGlobe as any, { className });
};

export const FiClock: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiClock as any, { className });
};

export const FiCheckCircle: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiCheckCircle as any, { className });
};

export const FiAlertCircle: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiAlertCircle as any, { className });
};

export const FiX: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiX as any, { className });
};

export const FiMessageSquare: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiMessageSquare as any, { className });
};

export const FiPlus: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiPlus as any, { className });
};

export const FiDatabase: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiDatabase as any, { className });
};

export const FiCloud: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiCloud as any, { className });
};

export const FiActivity: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiActivity as any, { className });
};

export const FiAlertTriangle: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiAlertTriangle as any, { className });
};

export const FiCheck: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiCheck as any, { className });
};

export const FiSearch: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiSearch as any, { className });
};

export const FiChevronLeft: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiChevronLeft as any, { className });
};

export const FiXCircle: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiXCircle as any, { className });
};

export const FiEye: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiEye as any, { className });
};

export const FiFileText: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiFileText as any, { className });
};

export const FaRobot: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FaIcons.FaRobot as any, { className });
};

// Additional icons for new components
export const FolderIcon = FiFolder;
export const PlusIcon = FiPlus;
export const EditIcon: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiEdit2 as any, { className });
};
export const TrashIcon = FiTrash2;
export const FileTextIcon = FiFileText;
export const ClockIcon = FiClock;
export const FileUploadIcon = FiUpload;
export const SendIcon: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiSend as any, { className });
};
export const FileIcon = FiFile;

export const FiPlay: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiPlay as any, { className });
};

export const FiRotateCcw: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiRotateCcw as any, { className });
};

export const FiSettings: React.FC<{ className?: string }> = ({ className }) => {
  return React.createElement(FiIcons.FiSettings as any, { className });
};